import { render, staticRenderFns } from "./OwnerType.vue?vue&type=template&id=12a65bc3&scoped=true&"
import script from "./OwnerType.vue?vue&type=script&lang=js&"
export * from "./OwnerType.vue?vue&type=script&lang=js&"
import style0 from "./OwnerType.vue?vue&type=style&index=0&id=12a65bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a65bc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a65bc3')) {
      api.createRecord('12a65bc3', component.options)
    } else {
      api.reload('12a65bc3', component.options)
    }
    module.hot.accept("./OwnerType.vue?vue&type=template&id=12a65bc3&scoped=true&", function () {
      api.rerender('12a65bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/select/OwnerType.vue"
export default component.exports